import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { FeatureCode, ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { take } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Features } from '../../business-entities/user-role-view-model';
import { VerticalMenuItem } from '../../business-entities/vertical-menu-item.model';
import { RolesRightsService } from '../../business-services/roles-rights.service';
import { CultureLocaleService } from '../../services/culture-locale.service';
import * as Constants from './../../../../../Autofacets-Core/src/app/utils/constant';
import { ApplicationVersionService } from './../../business-services/application-version.service';
import { ReleaseNotesComponent } from './release-note/release-notes/release-notes.component';
@Component({
    selector: 'app-menu',
    templateUrl: 'menu.component.html',
    styleUrls: []
})
export class MenuComponent implements OnInit{
    verticalMenu: VerticalMenuItem[];
    Menu: VerticalMenuItem[];
    features: Features[] = [];
    updatedVerticalMenu:VerticalMenuItem[];
    latestVersionNumber:string;
    latestReleaseNote:string;
    latestInternalReleaseNote:string;
    isSuperUser: boolean = false;
    UpdatedVerticalMenuDetails:any;
    constructor(
        private userService: UserDataService,
        private rolesRightsService: RolesRightsService,
        public spinner: NgxSpinnerService,
        private secureStorage: SecureStorage,
        private modalService: NgbModal,
        private ApplicationVersionService : ApplicationVersionService,
        private cultureService: CultureLocaleService,
        private currentLanguageService: CurrentLanguage,
    ) { }

    ngOnInit(): void {
        this.Menu = [...Constants.VerticalMenu];
        this.userService.currentUser.pipe(take(2)).subscribe((userDetails) => {
            if (userDetails) {
                this.isSuperUser = userDetails.roleTypeText?.toLowerCase() === 'super admin';
                this.GetFeature(userDetails);
            }
        });
        this.getVersionNumberList();
    }
    GetFeature(userDetails:any){
        this.secureStorage.removeKey('feature');
        this.spinner.show();
        this.rolesRightsService.getFeatures().then((res)=>{
          if(res.responseObject.errorCount === 0){
            this.features = res.responseObject.result;
            if(this.features && this.features.length >0){
                this.secureStorage.setKeyData('feature', this.features);
                this.currentLanguageService.featureList.next(this.features);
                this.userService.feature = this.features;
                this.UpdatedVerticalMenuDetails = Constants.VerticalMenu;
                if((this.features.find(x=>x.featureCode === FeatureCode.RenatlCar)?.isActive === false) || (this.features.find(x=>x.featureCode === FeatureCode.GRentalCar)?.isActive)){
                  this.UpdatedVerticalMenuDetails[2].submenu = this.UpdatedVerticalMenuDetails[2].submenu.filter(x=>x.id !== ModuleNames.RentalVehicle);
              }
               if(this.features.find(x=>x.featureCode == FeatureCode.PickupDropoff)?.isActive ===false){
                  this.UpdatedVerticalMenuDetails[9].submenu = this.UpdatedVerticalMenuDetails[9].submenu.filter(x=>x.id !== ModuleNames.PickupDropoff);
                  this.UpdatedVerticalMenuDetails[9].submenu = this.UpdatedVerticalMenuDetails[9].submenu.filter(x=>x.id !== ModuleNames.CustomerPickDrop);
               }
               if(this.features.find(x=>x.featureCode == FeatureCode.CheckInUsageReport)?.isActive ===false){
                this.UpdatedVerticalMenuDetails[9].submenu = this.UpdatedVerticalMenuDetails[9].submenu.filter(x=>x.id !== ModuleNames.CheckInUsage);
             }
              if( this.features.find(x=>x.featureCode === FeatureCode.SyncJobs)?.isActive === false){
                 this.UpdatedVerticalMenuDetails[3].parentsubmenu[2].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[2].submenu.filter(x=>x.id !== ModuleNames.SyncJobs);
              }
              if(this.features.find(x=>x.featureCode === FeatureCode.UserStampInOut)?.isActive === false){
                 this.UpdatedVerticalMenuDetails[8].submenu = this.UpdatedVerticalMenuDetails[8].submenu.filter(x=>x.id !== ModuleNames.UserClockInOut && x.id !== ModuleNames.UserStampReport);
                }
              if(this.features.find(x=>x.featureCode === FeatureCode.SpecialTool)?.isActive === false){
                  //specialtool
                  this.UpdatedVerticalMenuDetails[3].parentsubmenu[1].submenu =  this.UpdatedVerticalMenuDetails[3].parentsubmenu[1].submenu.filter(x=>x.id !== ModuleNames.SpecialTools)
                  //Brand Tools
                  this.UpdatedVerticalMenuDetails[2].submenu =  this.UpdatedVerticalMenuDetails[2].submenu.filter(x=>x.id !== ModuleNames.DealerSpecialTools)
              }
              if((!this.features.find(x=>x.featureCode == FeatureCode.AllowAccount)?.isActive) ){
                  this.UpdatedVerticalMenuDetails[1].submenu =  this.UpdatedVerticalMenuDetails[1].submenu.filter(x=>x.id !== ModuleNames.Accounts)
              }
              if(!(this.features.find(x=>x.featureCode == FeatureCode.ShareBox)?.isActive) ){
                  this.UpdatedVerticalMenuDetails[2].submenu =  this.UpdatedVerticalMenuDetails[2].submenu.filter(x=>x.id !== ModuleNames.AutoKey)
              }
              if (this.features.find(x => x.featureCode === FeatureCode.DWO)?.isActive === false) {
                  this.UpdatedVerticalMenuDetails.splice(4, 1);
              }
              if(this.features.find(x=>x.featureCode == FeatureCode.AgentEfficiencyReport)?.isActive ===false){
                this.UpdatedVerticalMenuDetails[9].submenu = this.UpdatedVerticalMenuDetails[9].submenu.filter(x=>x.id !== ModuleNames.AgentEfficiency);
             }
              if(this.features.find(x=>x.featureCode == FeatureCode.CallDealerLogsReport)?.isActive ===false){
                this.UpdatedVerticalMenuDetails[9].submenu = this.UpdatedVerticalMenuDetails[9].submenu.filter(x=>x.id !== ModuleNames.CallDealerLogs);
             }
              if (this.features.find(x => x.featureCode === FeatureCode.WarningLight)?.isActive === false || this.features.findIndex(x => x.featureCode === FeatureCode.WarningLight)===-1) {
                this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu.filter(x=>x.id !== ModuleNames.WarningLights);
                }
            //if feature flag is off or feature not founf consider false - Preferences
            if (this.features.find(x => x.featureCode === FeatureCode.Preferences)?.isActive === false  || this.features.findIndex(x => x.featureCode === FeatureCode.Preferences)===-1) {
                this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu.filter(x=>x.id !== ModuleNames.Preferences);
            }
             //if feature flag is off or feature not founf consider false - Promotions
            if (this.features.find(x => x.featureCode === FeatureCode.Promotions)?.isActive === false  || this.features.findIndex(x => x.featureCode === FeatureCode.Promotions)===-1) {
                this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu.filter(x=>x.id !== ModuleNames.Promotions);
                this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[0].submenu.filter(x=>x.id !== ModuleNames.Category);
            }
            if (this.features.find(x => x.featureCode === FeatureCode.PARTS)?.isActive === false)
            {
                this.UpdatedVerticalMenuDetails[3].parentsubmenu[1].submenu = this.UpdatedVerticalMenuDetails[3].parentsubmenu[1].submenu.filter(x=>x.id !== ModuleNames.Parts);
                this.UpdatedVerticalMenuDetails[2].submenu = this.UpdatedVerticalMenuDetails[2].submenu.filter(x=>x.id !== ModuleNames.DealerParts);
            }
            if (this.features.find(x => x.featureCode === FeatureCode.AutomaticUpdates)?.isActive === false)
            {
                this.UpdatedVerticalMenuDetails[5].submenu = this.UpdatedVerticalMenuDetails[5].submenu.filter(x=>x.id !== ModuleNames.AutomaticUpdates);
            }
                    this.GetMenuList(userDetails)
            }
          }
        })
        this.spinner.hide();
      }

      GetMenuList(userDetails:any){
        this.verticalMenu = this.UpdatedVerticalMenuDetails.slice().map(menuItem => {
            if (menuItem.submenu && menuItem.submenu.length > 0) {
                const submenu = menuItem.submenu.filter(subMenuItem => {
                    const roleDetails = (userDetails.userRoleMenuDetails as any[]).find(x => x.moduleId === subMenuItem.id && x.canView);
                    return !!roleDetails;
                }).filter(x => x !== null);
                return submenu.length > 0 ? { ...menuItem, submenu: submenu } : null;
            }
            if ( menuItem.parentsubmenu?.length > 0) {
               const parentmenu = menuItem.parentsubmenu.filter(element => {
                    const submenu = element.submenu?.filter(subMenuItem => {
                        const roleDetails = (userDetails.userRoleMenuDetails as any[]).find(x => x.moduleId === subMenuItem.id && x.canView);
                        return !!roleDetails;
                    }).filter(x => x !== null);
                    let parent;
                    if(submenu && submenu.length > 0){
                    parent = { name: element.name, ...submenu}
                    element.submenu = submenu;
                    }
                    else{
                        element.submenu = null;
                    }
                    return !!parent;
                }).filter(x=>x !== null)
                return parentmenu.length > 0 ? { ...menuItem, parentsubmenu: parentmenu } : null;
                }
            else {
                const roleDetails = (userDetails.userRoleMenuDetails as any[]).find(x => x.moduleId === menuItem.id && x.canView);
                return roleDetails ? { ...menuItem } : null;
            }
        }).filter(x => x !== null);
      }
      toggleMenu(item){
        item.isOpen = !item.isOpen;
      }
    goTo(index: number): void {
        this.verticalMenu.forEach((item, itemIndex) => {
            if (itemIndex === index) {
                if (item.parentsubmenu && item.parentsubmenu.length > 0) {
                   this.toggleMenu(item);
                } else if (item.submenu) {
                    this.toggleMenu(item);
                }
            } else if (item.parentsubmenu && item.isOpen === true) {
                this.toggleMenu(item);
            } else if (item.submenu) {
                item.isOpen = false;
            }
        });
    }
    OpenReleaseNotes(): void {
        const modalref = this.modalService.open(ReleaseNotesComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
        modalref.componentInstance.releaseNote = this.latestReleaseNote;
        modalref.componentInstance.internalReleaseNote = this.latestInternalReleaseNote;
        modalref.componentInstance.isSuperUser = this.isSuperUser;
      }
      getVersionNumberList(){
        this.ApplicationVersionService.getVersionNumberList().then(response => {
          if (response) {
            let versionNumberList = response.responseObject;
            versionNumberList.sort((a, b) => {
                const versionA = a.versionNo.split('.').map(Number);
                const versionB = b.versionNo.split('.').map(Number);
            
                for (let i = 0; i < versionA.length; i++) {
                    if (versionA[i] !== versionB[i]) {
                        return versionB[i] - versionA[i];
                    }
                }
                return 0;
            });
            
            this.latestVersionNumber = versionNumberList[0]?.versionNo?.length > 0 ? versionNumberList[0]?.versionNo : '1.0.0';
            this.latestReleaseNote = versionNumberList[0]?.releaseNote;
            this.latestInternalReleaseNote = versionNumberList[0]?.internalReleaseNote;
          }
          else if (response.responseObject && response.responseObject.errorCount > 0) {
              this.spinner.hide();
            }
         this.spinner.hide();
       });
      }
}
